import { Component, computed, input } from '@angular/core';
import { BreadcrumbCurrent, BreadcrumbLink, Breadcrumbs } from './types';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'breadcrumb',
  template: `
    <nav class="breadcrumb">
      @for (link of links(); track link.title) {
        <a class="breadcrumb-link" [routerLink]="link.href">{{ link.title }}</a>
        <svg
          class="breadcrumb-sep"
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <polyline points="9 18 15 12 9 6" />
        </svg>
      }
      <span class="breadcrumb-current">{{ currentPage().title }}</span>
    </nav>
  `,
  styles: `
    .breadcrumb {
      display: flex;
      align-items: center;
      gap: 4px;
      margin-bottom: 20px;
      flex-shrink: 0;
    }

    .breadcrumb-sep {
      color: #bdbdbd;
      flex-shrink: 0;
    }

    .breadcrumb-link {
      font-size: 14px;
      color: #007db7;
      cursor: pointer;
      font-family: var(--font, system-ui, sans-serif);
      white-space: nowrap;
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }

    .breadcrumb-current {
      font-size: 14px;
      color: #616161;
      font-family: var(--font, system-ui, sans-serif);
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  `,
  imports: [RouterLink],
})
export class Breadcrumb {
  readonly breadcrumbs = input.required<Breadcrumbs>();
  // NOTE: Type assertions fine as they match Breadcrumbs type,
  // i.e. all elements have href except the last one.
  readonly links = computed(() => {
    return this.breadcrumbs().slice(0, -1) as BreadcrumbLink[];
  });
  readonly currentPage = computed(() => {
    return this.breadcrumbs().at(-1) as BreadcrumbCurrent;
  });
}
